import img from "./assets/drop.png";
import Popup from "reactjs-popup";
import React, {useState} from "react";
import ApplyModal from "../../../GlobalComponents/ApplyModal/ApplyModal";
const CheckOut = () => {
  const [openBid, setOpenBid] = useState(false);
  return (
    <div className="bg-custom-gradient mt-[80px] md:mt-[104px] pt-[57px] pb-[58px]">
      <div className="container">
        <div className="max-w-[1044px] mx-auto">
          <div className="flex flex-col md:flex-row gap-[52px]">
            <div className="md:w-[374px] flex-none">
              <img className="w-full" src={img} alt="" />
            </div>
            <div className="grow">
              <h4 className="mb-[4px] text-res-normal text-light-black font-bold">
                Invest in the Future of DeFi:
              </h4>
              <h2 className="text-[28px] mb-[4px] md:text-[36px] leading-[43px] font-black">
                Check Out Our Latest Funded Projects
              </h2>
              <p className="text-res-ls leading-[22px] text-light-black font-semibold mb-[11px]">
                As a member of the R34P DAO, you have the opportunity to shape
                the future of decentralized finance by investing in cutting-edge
                projects. Check out our latest funded projects and be a part of
                the revolution!
              </p>
              <button onClick={() => setOpenBid(true)} className="rounded-[20px] flex justify-center items-center bg-light-black w-[128px] h-[29px] text-[15px] leading-[18px] font-bold">
                <span>Apply Now</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <Popup open={openBid} position="right center">
        <div className="modalOverlay"></div>
        <ApplyModal
          open={openBid}
          setOpen={setOpenBid}
        ></ApplyModal>
      </Popup>
    </div>
  );
};

export default CheckOut;
